export const roleMixin = {
  data() {
    return {
      // Cargamos el rol una sola vez por componente.
      currentUserRole: localStorage.getItem("ew-user-role") || null,
    };
  },
  methods: {
    /**
     * Verifica si el rol actual del usuario está incluido en la lista de roles permitidos.
     * @param {string|Array<string>} roles - Un rol (string) o una lista de roles (array) permitidos.
     * @returns {boolean} - True si el rol está permitido, False si no.
     */
    hasRole(roles) {
      if (!this.currentUserRole) {
        return false;
      }

      // Aseguramos que 'roles' sea siempre un array para usar .includes()
      const allowedRoles = Array.isArray(roles) ? roles : [roles];

      return allowedRoles.includes(this.currentUserRole);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/roleMixin.js